<template>
  <v-footer fixed :padless="true">
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
      max-width="380px"
    >
      <template v-slot:activator="{ on }">
        <v-fab-transition v-model="dialog">
          <v-btn
            color="var(--vs-vermelho)"
            v-on="on"
            dark
            absolute
            bottom
            right
            fab
            x-large
            class="mr-5 mb-12"
            @click="setScrollEnd()"
            v-if="user"
          >
            <v-badge
              color="var(--vs-azul-primaria)"
              v-if="msgsNovas === true"
              class="align-self-end"
              overlap
            >
              <template v-slot:badge v-if="countMsg > 0">
                <span style="margin-bottom: 1px !important;">
                  {{ countMsg }}
                </span>
              </template>
              <span>Chat</span>
              <!-- <v-icon>la-comments</v-icon> -->
            </v-badge>
            <span v-else>Chat</span>
            <!-- <v-icon v-else>la-comments</v-icon> -->
          </v-btn>
        </v-fab-transition>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="var(--vs-azul-primaria)"
          elevation="0"
          modal="false"
          class="border-inferior-gold-2px"
        >
          <v-card-title class="pl-0">
            <span class="subtitle-2">Converse com a concessionária</span>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>la-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text
          style="height: 300px;"
          class="pt-2 border-inferior-gold"
          v-chat-scroll="{ always: false, smooth: true }"
          id="chat-scroll"
        >
          <v-card
            v-for="mensagem in mensagens"
            :key="mensagem.chtIntCod"
            elevation="0"
            translate
            class="py-1"
          >
            <v-card
              v-if="mensagem.chtQuemEnviou === 'C'"
              elevation="0"
              class="pa-1 pl-2 message-user"
              style="display: flow-root !important;"
            >
              <span
                class="pa-1 pl-2 pb-0 pt-2 message-user-name font-weight-bold d-flex"
                >{{ mensagem.cliente.cliStrNme }}</span
              >

              <span
                class="pa-1 pl-2 caption font-weight-regular d-flex"
                v-html="mensagem.chtStrTexto"
              ></span>
              <span class="mr-2 pt-0 font-weight-regular d-flex float-right">
                {{ mensagem.chtDtmCriacao | formatDateTime }}

                <v-icon v-if="mensagem.chtDtmLeitura != null && mensagem.chtQuemEnviou === 'C'" class="ml-2 pt-0 float-right" color="var(--vs-azul-primaria)">la-check-double</v-icon>
                <v-icon v-else class="ml-2 pt-0 float-right"  color="var(--vs-cinza)">la-check</v-icon>
              </span>
            </v-card>
            <v-card
              v-if="mensagem.chtQuemEnviou === 'F'"
              elevation="0"
              class="pa-1 pl-2 message-funcionario"
              style="display: flow-root !important;"
            >
              <span v-if="mensagem.funcionario != null" 
                class="pa-1 pl-2 pb-0 pt-2 message-funcionario-name font-weight-bold d-flex"
                >{{ mensagem.funcionario.funStrNme }}</span
              >

              <!-- <span class="pa-1 pl-2 caption font-weight-regular d-flex">{{ mensagem.chtStrTexto }}</span> -->
              <span
                class="pa-1 pl-2 caption font-weight-regular d-flex black--text"
                v-html="mensagem.chtStrTexto"
              ></span>
              <span class="mr-2 pt-0 font-weight-regular d-flex float-right">
                {{ mensagem.chtDtmCriacao | formatDateTime }}
              </span>
            </v-card>
          </v-card>
        </v-card-text>
        <v-card-actions class="mt-1">
          <v-textarea
            v-model="descricao"
            placeholder="Digite uma mensagem..."
            outlined
            flat
            color="#CDB08E"
            @keyup.enter="enviarMensagem"
            id="areaDescricao"
            height="80"
          ></v-textarea>
          <!-- <v-btn color="grey darken-1" icon>
            <v-icon>la-paperclip</v-icon>
          </v-btn>-->
          <v-btn
            color="var(--vs-azul-primaria)"
            class="ml-2"
            fab
            small
            depressed
          >
            <v-icon class="white--text" @click="enviarMensagem()"
              >la-telegram</v-icon
            >
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      dialog: false,
      descricao: "",
      ws: null,
      ultmsg: ''
    };
  },
  methods: {
    enviarMensagem() {
      let obj = {};
      obj.chtDtmCriacao = new Date().toISOString();
      obj.cliente = this.user;
      obj.chtStrTexto = this.descricao;
      obj.chtQuemEnviou = "C";
      // console.log("ENVIAR MSG", obj);
      if (event.shiftKey === true && event.key === "Enter") {
        return;
      }
      if (obj.chtStrTexto !== "") {
        // this.ws.send(JSON.stringify({ message: obj }));
        this.$store.dispatch("chat/contadorMsg", 0);
        this.$store.dispatch("chat/postarMensagem", obj);
        // this.setDataLeitura();
      } else {
        // alert("Preencha")
      }
      this.descricao = "";
    },
    setDataLeitura() {
      // console.log("USUÁRIO", this.user.cliIntCod, "ÚLTIMO ID ARRAY", this.ultimamsg);
      if (this.user) {
        this.$store.dispatch("chat/setDataLeituraMensagens", {
          cliIntCod: this.user.cliIntCod,
          chtIntCod: this.ultmsg,
        });
      }
    },
    setScrollEnd() {
      setTimeout(() => {
        // console.log("CLICK SET SCROLL END");
        var setScrollEnd = document.getElementById("chat-scroll");
        // console.log("DIV TO SET END", setScrollEnd);
        setScrollEnd.scrollTop = setScrollEnd.scrollHeight;
      }, 1000);
      if (this.user && this.user.cliIntCod) {
        this.$store.dispatch("chat/carregarMensagens", this.user.cliIntCod);
      }
      // this.removeNovidadeCliente();
      this.$store.dispatch("chat/mensagensNova", false);
      this.setDataLeitura();
    },
    // removeNovidadeCliente() {
    //   // console.log("removeNovidadeCliente")
    //   if (this.user && this.user.cliIntCod) {
    //     //  console.log("removeNovidadeCliente", this.user, this.user.cliIntCod)
    //     this.$store.dispatch("chat/removerNovidadeMensagensNova", {
    //       cliIntCod: this.user.cliIntCod,
    //     });
    //   }
    // },
  },
  computed: {
    ...mapGetters({
      user: "cliente/user",
      mensagens: "chat/mensagens",
      ultimamsg: "chat/ultimamsg",
      temMensagem: "chat/temMensagem",
      msgsNovas: "chat/msgsNovas",
      countMsg: "chat/countMsg",
    }),
  },
  mounted() {
    this.ultmsg = this.ultimamsg
  }
};
</script>

<style scoped>
.v-dialog__content {
  align-items: flex-end;
  justify-content: flex-end;
  top: 5px;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}

.message-user {
  /* border-radius: 1.125rem 1.125rem 1.125rem 0; */
  border-radius: 0.75rem 0.75rem 0 0.75rem !important;
  background-color: rgb(218, 232, 242) !important;
  border-color: rgb(218, 232, 242) !important;
  color: #414141 !important;
  caret-color: #414141 !important;
  font-size: 10px !important;
  box-shadow: 0 0 2rem rgba(black, 0.075), 0rem 1rem 1rem -1rem rgba(black, 0.1) !important;
  margin-left: 60px;
}

.message-user-name {
  font-size: 14px !important;
  font-weight: bold;
}

.message-user:before {
  content: "";
  width: 0px;
  height: 0px;
  display: block;
  border-left: 3px solid #dae8f2;
  border-right: 3px solid transparent;
  border-top: 3px solid #dae8f2;
  border-bottom: 3px solid transparent;
  position: absolute;
  bottom: 0px;
  right: -5px;
  transform: scaleY(-1);
}

.message-funcionario {
  /* border-radius: 1.125rem 1.125rem 1.125rem 0; */
  border-radius: 0.75rem 0.75rem 0.75rem 0 !important;
  background-color: #ececec !important;
  border-color: #ececec !important;
  color: #414141 !important;
  caret-color: #414141 !important;
  font-size: 10px !important;
  box-shadow: 0 0 2rem rgba(black, 0.075), 0rem 1rem 1rem -1rem rgba(black, 0.1) !important;
  width: 85%;
}

.message-funcionario-name {
  font-size: 14px !important;
  font-weight: bold;
}

.message-funcionario:before {
  content: "";
  width: 0px;
  height: 0px;
  display: block;
  border-left: 3px solid #ececec;
  border-right: 3px solid transparent;
  border-top: 3px solid #ececec;
  border-bottom: 3px solid transparent;
  position: absolute;
  bottom: 0px;
  left: -5px;
  /* transform: scaleY(-1); */
  /* transform: scaleX(-1); */
  transform: rotate(180deg);
}
</style>
